import type { UrlParam } from '../../../hooks/useParam'

const FILTER_ITEM_DELIMITER = '|'
const FILTER_VALUE_DELIMITER = '='

export interface DataSelectionFilters {
  [key: string]: string
}

export const dataSelectionFiltersParam: UrlParam<DataSelectionFilters> = {
  name: 'filters',
  defaultValue: {},
  decode: (value) => {
    return value.split(FILTER_ITEM_DELIMITER).reduce<DataSelectionFilters>((filters, filter) => {
      const [key, val] = filter.split(FILTER_VALUE_DELIMITER)

      if (!key || !val) {
        return filters
      }

      return { ...filters, [key]: val }
    }, {})
  },
  encode: (value) => {
    return Object.keys(value)
      .map((key) => [key, value[key]].join(FILTER_VALUE_DELIMITER))
      .join(FILTER_ITEM_DELIMITER)
  },
}
